exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".draw-canvas[data-v-d03a73d8]{display:block}", "", {"version":3,"sources":["/workspace/src/views/question-review/components/AnswerFileFullScreen/src/DrawOverlayCanvas.vue"],"names":[],"mappings":"AACA,8BAA8B,aAAa,CAC1C","file":"DrawOverlayCanvas.vue","sourcesContent":["\n.draw-canvas[data-v-d03a73d8]{display:block\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d03a73d8","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/question-review/components/AnswerFileFullScreen/src/DrawOverlayCanvas.vue
// module id = 1724
// module chunks = 5 34 108 122